import { ApiScreeningSearchHit } from '../../api';
import React, { Fragment, useState } from 'react';
import Card from 'react-bootstrap/Card';
import Table from '../../table/Table';

const sliceResultsByPage = (results: ApiScreeningSearchHit[], size: number, page: number) => {
  const offset = page * size;
  return results.slice(offset, offset + size);
};

interface Props {
  results: ApiScreeningSearchHit[];
}

const attemptJSONPrettyPrint = (input: ApiScreeningSearchHit) => {
  try {
    return JSON.stringify(input, null, 2);
  } catch (_) {
    return 'could not stringify hit';
  }
};

export const ScreeningTestsSandboxResults = ({ results }: Props) => {
  const size = 20;
  const [page, setPage] = useState(0);
  const hits = sliceResultsByPage(results, size, page);
  return (
    <Card>
      <Card.Body>
        {results.length ? (
          <Table
            title='Hits'
            className='table-fixed'
            page={page}
            size={size}
            total={results.length}
            items={hits}
            fetchPage={setPage}
            header={() => (
              <tr>
                <th>Data</th>
              </tr>
            )}
            body={() =>
              results.map((hit: ApiScreeningSearchHit, index) => (
                <Fragment key={index}>
                  <tr className={`custom-table-row-${index % 2}`}>
                    <td>
                      <pre>{attemptJSONPrettyPrint(hit)}</pre>
                    </td>
                  </tr>
                </Fragment>
              ))
            }
          />
        ) : (
          <span>No results...</span>
        )}
      </Card.Body>
    </Card>
  );
};

export default ScreeningTestsSandboxResults;
